import React from 'react';
import { Link } from 'react-router-dom';

class LoggedOutIndex extends React.Component<{}, {}> {
    public render() {
        return <React.Fragment>
            <section className="section">
                <div className="deck">
                    <div className="w--md banner-title">
                        <h2>Logget ud</h2>
                        <p>Du er nu logget ud. Klik <Link to="/">her</Link> for at logge ind igen.</p>
                    </div>
                </div>
            </section>
        </React.Fragment>;
    }
}

export default LoggedOutIndex;